import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '@/views/Home/HomeView.vue'
import { cookieUtil } from '@/utils/cookie'
import { appealConsultationAPI } from '@/api/appealConsultation'
import { store } from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView,
  //   meta: {
  //     title: '首页'
  //   }
  // },
  {
    path: '/',
    name: 'policy',
    component: () => import('@/views/Policy/NewPolicyView.vue'),
    meta: {
      title: '政策服务'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/searchHome',
    name: 'searchHome',
    component: () => import('@/views/Home/SearchHomeView.vue'),
    meta: {
      title: '检索页'
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Others/UndefinedView.vue'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/developing',
    name: 'developing',
    component: () => import('@/views/Others/DevelopingView.vue'),
    meta: {
      title: 'developing'
    }
  },
  // {
  //   path: '/policy',
  //   name: 'policy',
  //   component: () => import('@/views/Policy/PolicyView.vue'),
  //   meta: {
  //     title: '政策服务'
  //   }
  // },
  {
    path: '/policy/policyList',
    name: 'policyList',
    component: () => import('@/views/Policy/PolicyList/PolicyListView.vue'),
    meta: {
      title: '政策列表'
    }
  },
  {
    path: '/policy/policyDetail',
    name: 'policyDetail',
    component: () => import('@/views/Policy/PolicyList/PolicyDetailView.vue'),
    meta: {
      title: '政策详情'
    }
  },
  {
    path: '/policy/policyDetailRead',
    name: 'policyDetailRead',
    component: () => import('@/views/Policy/PolicyList/PolicyDetailReadView.vue'),
    meta: {
      title: '政策解读'
    }
  },
  {
    path: '/policy/enterpriseTest',
    name: 'enterpriseTest',
    component: () => import('@/views/Policy/EnterpriseTest/EnterpriseTestView.vue'),
    meta: {
      title: '企业自测'
    }
  },
  {
    path: '/policy/enterpriseTestDetail',
    name: 'enterpriseTestDetail',
    component: () => import('@/views/Policy/EnterpriseTest/EnterpriseTestDetailView.vue'),
    meta: {
      title: '企业自测'
    }
  },
  {
    path: '/policy/policyMatch',
    name: 'policyMatch',
    component: () => import('@/views/Policy/PolicyMatch/PolicyMatchView.vue'),
    meta: {
      title: '政策匹配'
    }
  },
  {
    path: '/myself/index',
    name: 'myselfIndex',
    component: () => import('@/views/Myself/MyselfIndexView.vue'),
    meta: {
      title: '用户中心'
    }
  },
  {
    path: '/myself',
    name: 'myself',
    component: () => import('@/views/Myself/MyselfView.vue'),
    meta: {
      title: '我的'
    },
    children: [
      {
        path: '/myself/appeal',
        name: 'myselfAppeal',
        component: () => import('@/views/Myself/MyselfAppealView.vue'),
        meta: {
          title: '我的办件'
        }
      },
      {
        path: '/myself/appealDetail',
        name: 'myselfAppealDetail',
        component: () => import('@/views/Myself/MyselfAppealDetailView.vue'),
        meta: {
          title: '办件详情'
        }
      },
      {
        path: '/myself/subscription',
        name: 'myselfSubscription',
        component: () => import('@/views/Myself/MyselfSubscriptionView.vue'),
        meta: {
          title: '我的订阅'
        }
      },
      {
        path: '/myself/subscriptionDetail',
        name: 'myselfSubscriptionDetail',
        component: () => import('@/views/Myself/MyselfSubscriptionDetailView.vue'),
        meta: {
          title: '订阅详情'
        }
      },
      {
        path: '/myself/cash',
        name: 'myselfCash',
        component: () => import('@/views/Myself/MyselfCashView.vue'),
        meta: {
          title: '我的兑现'
        }
      },
      {
        path: '/myself/declare',
        name: 'myselfDeclare',
        component: () => import('@/views/Myself/MyselfDeclareView.vue'),
        meta: {
          title: '我的申报'
        }
      },
      {
        path: '/myself/message',
        name: 'myselfMessage',
        component: () => import('@/views/Myself/MyselfMessageView.vue'),
        meta: {
          title: '我的消息'
        }
      },
      {
        path: '/myself/law',
        name: 'myselfLaw',
        component: () => import('@/views/Myself/Law/index.vue'),
        meta: {
          title: '法律法治'
        }
      },
      {
        path: '/myself/lawDetail',
        name: 'myselfLawDetail',
        component: () => import('@/views/Myself/Law/detail.vue')
      }
    ]
  },
  {
    path: '/myself/policyReadList',
    name: 'policyReadList',
    component: () => import('@/views/Myself/Policy/PolicyReadListView.vue'),
    meta: {
      title: '政策浏览记录'
    }
  },
  {
    path: '/myself/policyRecommend',
    name: 'policyRecommend',
    component: () => import('@/views/Myself/Policy/PolicyRecommendListDetail.vue'),
    meta: {
      title: '政策推荐'
    }
  },
  {
    path: '/myself/polMatchList',
    name: 'policyMatchList',
    component: () => import('@/views/Myself/Policy/PolicyMatchListView.vue'),
    meta: {
      title: '政策匹配记录'
    }
  },
  {
    path: '/myself/polMatchDetailList',
    name: 'policyMatchDetailList',
    component: () => import('@/views/Myself/Policy/PolicyMatchDetailListView.vue'),
    meta: {
      title: '政策匹配记录详情'
    }
  },
  {
    path: '/law',
    name: 'law',
    component: () => import('@/views/Law/LawView.vue'),
    meta: {
      title: '法治服务'
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('to', to)
  if (to.matched.length === 0) {
    next('/404')
    // next('developing')
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})

router.beforeEach((to, from, next) => {
  // console.log('准备请求用户信息', store.state.isLogin)
  if (!store.state.isLogin) {
    const accessToken = cookieUtil.getCookie('accessToken')
    appealConsultationAPI.getUserInfo({ token: accessToken }).then(res => {
      if (res.success) {
        console.log(res, '用户信息请求成功')
        store.commit('changeUserId', res.data.user.iid)
        store.commit('changeUserType', res.data.user.userType)
        store.commit('changeLoginStatus', true)
        next()
      } else {
        console.log(res, '用户信息请求失败')
        next()
      }
    })
  } else {
    next()
  }
})

// router.beforeEach((to, from, next) => {
//   const lastUrl = cookieUtil.getCookie('redirect')
//   if (lastUrl !== '' && to.path !== 'policy' && to.path !== 'login') {
//     cookieUtil.clearCookie('redirect')
//     location.href = lastUrl
//     // next('developing')
//   } else {
//     next()
//   }
// })

export default router
